import React, { useState } from 'react';
import {
  Box, Typography, Paper, Stack, Chip, Button,
} from '@mui/material';
import FlightIcon from '@mui/icons-material/Flight';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { useNavigate } from 'react-router-dom';
import PassengerList from '../components/TravelerScreening/PassengerList';
import AddPassengerDialog from '../components/TravelerScreening/AddPassengerDialog';
import QrScanner from '../components/TravelerScreening/QrScanner';

const TravelerScreeningPage: React.FC = () => {
  const [dialogOpen,  setDialogOpen]  = useState(false);
  const [scannerOpen, setScannerOpen] = useState(false);
  const [refresh,     setRefresh]     = useState(0);
  const navigate = useNavigate();

  const handleSaved = () => setRefresh(r => r + 1);

  const handleQrResult = (screeningId: number, token?: string, prefetched?: unknown) => {
    // Token-based pass view works for every logged-in user (HQ and
    // port-scoped agents alike); the by-ID dashboard page is HQ-only.
    // Only fall back to it for the legacy voyagesante:// deep-link format,
    // which carries no token.
    // `prefetched` is the pass data the scanner already fetched — handed to
    // the pass page via navigation state so it renders without refetching.
    if (token) {
      navigate(`/pass/${token}`, prefetched ? { state: { prefetched } } : undefined);
    } else {
      navigate(`/dashboard/traveler-screening/${screeningId}`);
    }
  };

  return (
    <Box>
      {/* Page header */}
      <Paper variant="outlined" sx={{ p: 2.5, mb: 3 }}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <FlightIcon sx={{ color: '#1f93ff', fontSize: 28 }} />
          <Box>
            <Typography variant="h5" fontWeight="bold">Traveler Screening</Typography>
            <Typography variant="body2" color="text.secondary">
              Ebola health screening linelist — Kenya · Voyage Santé+
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
              Traveler self-screen (no login): /screen
            </Typography>
          </Box>
          <Chip label="KEN" size="small" sx={{ ml: 'auto', bgcolor: '#e3f2fd' }} />
        </Stack>

        {/* QR scanner button */}
        <Box sx={{ mt: 2 }}>
          <Button
            variant="outlined"
            startIcon={<QrCodeScannerIcon />}
            onClick={() => setScannerOpen(true)}
            sx={{ borderColor: '#1f93ff', color: '#1f93ff' }}
          >
            Scan Health Pass QR
          </Button>
        </Box>
      </Paper>

      {/* Linelist */}
      <PassengerList
        refresh={refresh}
        onAddNew={() => setDialogOpen(true)}
      />

      {/* Add passenger wizard */}
      <AddPassengerDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onSaved={handleSaved}
      />

      {/* QR Scanner dialog */}
      <QrScanner
        open={scannerOpen}
        onClose={() => setScannerOpen(false)}
        onResult={handleQrResult}
      />
    </Box>
  );
};

export default TravelerScreeningPage;
